import { render } from "./SVGImage.vue?vue&type=template&id=453959d6&scoped=true"
import script from "./SVGImage.vue?vue&type=script&lang=js"
export * from "./SVGImage.vue?vue&type=script&lang=js"

import "./SVGImage.vue?vue&type=style&index=0&id=453959d6&lang=scss&scoped=true"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453959d6"]])

export default __exports__